module.exports = __webpack_public_path__ + "static/wide_title-64e7dfce9df7a8210a7d8cd0e701bb76.png";